import {
  BackupLimitsAction,
  LOAD_BACKUP_LIMITS,
  LOAD_BACKUP_LIMITS_FAIL,
  LOAD_BACKUP_LIMITS_SUCCESS,
  LoadBackupLimitsSuccess
} from "../actions";

export interface IBackupLimitsState {
  backupLimits: any;
  loading: boolean;
  loaded: boolean;
}

export const initialState: IBackupLimitsState = {
  backupLimits: null,
  loading: false,
  loaded: false
};

export function reducer(state: IBackupLimitsState = initialState, action: BackupLimitsAction): IBackupLimitsState {
  let payload: any;

  switch (action.type) {
    case LOAD_BACKUP_LIMITS:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_BACKUP_LIMITS_SUCCESS:
      payload = (<LoadBackupLimitsSuccess>action).payload;

      return {
        ...state,
        backupLimits: payload,
        loading: false,
        loaded: true
      };

    case LOAD_BACKUP_LIMITS_FAIL:
      return {
        ...state,
        backupLimits: null,
        loading: false,
        loaded: true
      };

  }

  return state;
}
